const surveyConfig = {
	type: 'social',
    mode: 'tabbed',
    cols: 1,
    title: "Colpuno Newsletter Registration",
    linkHeaderImage: "https://www.colpuno.com",
    tabs: [
        { key: 'newsletter', title: 'Newsletter Registration' },
    ],
    intro: {
        title: "🌟 Take control of your Nursing Career with COLPUNO! 🌟",
        description: "Ever felt unsure about the next steps in your nursing journey?\nNURA did, but with Colpuno, she discovered exactly what she needed to focus on to level up her career. 💼✨\n" +
            "Sign up for our newsletter and unlock career tools and resources designed just for you!\nIt’s like having a personal guide for your professional growth. 📈💡",
        descriptionRaw: "<p style='font-weight:500'>What you’ll get when you subscribe:</p><ul style='list-style-type:disclosure-closed;'>" +
            "<li style='margin-bottom:10px;'>🔧 Powerful Career Tools – Build your perfect CV and discover your strengths with our Big 5 Personality Test.</li>" +
            "<li style='margin-bottom:10px;'>🎯 Personalized Insights – Quickly find out what steps you need to take to reach your dream career.</li>" +
            "<li style='margin-bottom:10px;'>💬 Tips – Get advice that’s easy to understand and directly relevant to your nursing career.</li>" +
            "<li style='margin-bottom:10px;'>🎉 Fun Challenges & Giveaways – Participate in exciting activities that make career growth more enjoyable!</li>" +
            "</ul><p>Join the Colpuno family today and let’s build the career you’ve always wanted – one step at a time! 👩‍⚕️🌟</p>",
    },
    conclusion: { 
        label: "Privacy Policy",
        title: "Thank you for your interest.",
        description: "",
        showInviter: true,
    },
    finished: {
        tick: true,
        title: "Thank you for signing up. We will send you updates about Colpuno.",
        description: "",
        clickthru: {
            logo: require('@/assets/colpuno_logo.png'),
            text: 'Return to the Colpuno platform',
            link: 'https://www.colpuno.com',
        },
    },
};
const surveyFields = [];

surveyFields.push({ key: 'newsletter', tab: 'newsletter', type: 'group', label: "Newsletter Registration", cols: 2, items: [
    { key: 'email', type: 'email', label: "Email", required: true, colSpan: 2 },
    { key: 'get_updates_info', type: 'info', label: "Please enter your email address to receive helpful career insights from Colpuno and claim your free access.", colSpan: 2 },
    { key: 'first_name', type: 'text', label: "First name", required: true },
    { key: 'last_name', type: 'text', label: "Last name", required: true },
    { key: 'nurse_type', type: 'select', label: "Are you a nurse?", required: true, colSpan: 2,options: [ 'Not|Not a nurse', 'Train|In training to become a nurse', 'Nurse|I am a nurse' ] },
]});

export default { surveyConfig, surveyFields };